<template>
  <el-dialog :title="form.qrcodeName" :visible.sync="visible" width="400px" @close="handleClose">
    <div class="text-center">
      <div id="qrcode" style="width: 200px; height: 200px; margin: 0 auto;"></div>
      <p style="margin: 15px 0; font-size: 16px; font-weight: bold;">
        {{ form.qrcodeName }}
      </p>
      <p style="color: #999;">
        {{ form.remark }}
      </p>
    </div>

   
    <span slot="footer" class="dialog-footer">
      <!-- 新增下载按钮 -->
      <el-button type="primary" @click="downloadQRCode">
        下载二维码
      </el-button>
      <el-button @click="visible = false">
        {{ $t('common.close') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import QRCodeJS from 'qrcodejs2'
import QRCode from 'qrcode'     // 新增：用于生成可下载图片

export default {
  name: 'ViewQrcode',
  data() {
    return {
      visible: false,
      form: {
        qrcodeName: '',
        qrCodeUrl: '',
        remark: ''
      },
      qrcode: null
    }
  },
  methods: {
    open(data) {
      this.visible = true
      this.form = { ...data }
      this.$nextTick(() => {
        this.generateQRCode()
      })
    },
    handleClose() {
      if (this.qrcode) {
        this.qrcode.clear()
        document.getElementById('qrcode').innerHTML = ''
      }
      this.form = {
        qrcodeName: '',
        qrCodeUrl: '',
        remark: ''
      }
    },
    generateQRCode() {
      if (this.qrcode) {
        this.qrcode.clear()
        document.getElementById('qrcode').innerHTML = ''
      }

      if (this.form.qrCodeUrl) {
        this.qrcode = new QRCodeJS(document.getElementById('qrcode'), {
          text: this.form.qrCodeUrl,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCodeJS.CorrectLevel.L
        })
      }
    },
  
   // 👇 新增：下载二维码
    async downloadQRCode() {
      if (!this.form.qrCodeUrl) return

      try {
        // 使用 qrcode 库生成 data URL
        const dataUrl = await QRCode.toDataURL(this.form.qrCodeUrl, {
          width: 300,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        })

        // 创建临时链接并触发下载
        const link = document.createElement('a')
        link.href = dataUrl
        link.download = `${this.form.qrcodeName || 'qrcode'}.png`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (err) {
        console.error('下载二维码失败:', err)
        this.$message.error('生成二维码图片失败')
      }
  },
  beforeDestroy() {
    if (this.qrcode) {
      this.qrcode.clear()
    }
  }
}
}
</script>

<style scoped>
#qrcode {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #eee;
  padding: 10px;
}
</style>